<template>
    <div class="learning-admin-element-details" data-test-view="learning-admin-element-details">
        <div v-show="element.description">
            <div class="element-description overflow-wrap">
                <l-text :text="element.description" />
            </div>
            <hr />
        </div>

        <l-learning-element :element="element" :option-select-disabled="true" />

        <br />

        <div class="footer">
            <button class="btn" @click="closeModal">{{ $t("modal.close") }}</button>
            <button
                v-show="!element.frozen"
                class="btn btn-primary btn-raised"
                data-test-id="learning-element-edit-button"
                @click="editContent"
            >
                {{ $t(`learning.admin.element.details.btn.edit`) }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LLearningElement from "@/components/LLearningElement";
import LText from "@/components/LText";

export default {
    components: {
        LLearningElement,
        LText,
    },
    props: {
        elementId: {
            type: String,
            default: "",
        },
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
            getDetails: "learning/element/details",
        }),
        element() {
            return this.getDetails(this.elementId);
        },
    },
    methods: {
        editContent() {
            this.$router.push(
                `/learning/admin/element/${this.element.type}/${this.elementId}/edit`,
            );
        },
        closeModal() {
            this.$router.push("/learning/admin/element");
        },
    },
};
</script>

<style scoped>
h4 {
    font-weight: bold;
    margin-bottom: 0;
}
.learning-admin-element-details > h4:first-of-type {
    margin-top: 0;
}
</style>
